import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import { LinkContainer } from 'react-router-bootstrap';
// import moment from 'moment';
import { Spinner, Card, CardBody, Table, CardHeader } from 'reactstrap';
// import LoaderButton from '../loader-button/LoaderButton';
import Switch from 'react-switch';
// import FalconCardHeader from '../common/FalconCardHeader';
// import ButtonIcon from '../common/ButtonIcon';

// import { onError } from '../../libs/errorLib';
import Loader from '../common/Loader';
// import Loading from '../../components/Loading';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
import BZAPIService from '../../services/BZAPIService';
import Heading from '../common/Heading';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';

export default function SuperAdmin() {
  const [appVersion, setAppVersion] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [vendorLoading, setVendorLoading] = useState('');
  const [dashboardSectionsLoading, setDashboardSectionsLoading] = useState(false);
  const [vendors, setVendors] = useState(null);
  const [dashboardSections, setDashboardSections] = useState([
    { label: 'Integrations', value: 'displayIntegration', active: 1 },
    { label: 'Vendor Integrations', value: 'displayVendorIntegration', active: 1 },
    { label: 'Tenant Bug Stats', value: 'displayTenantBugStats', active: 1 },
    { label: 'ODD Bug stats', value: 'displayOddBugStats', active: 1 }
  ]);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const vendors = await BZAPIService.getVendors();
        const appVersion = await BZAPIService.getAppVersion();
        setAppVersion(appVersion);
        setVendors(vendors);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
      try {
        const dashboard = await BZAPIService.getBzDashboard();
        const res = dashboard.data;
        setDashboardSections(isEmpty(res) ? dashboardSections : res.bugZeroDashboard.display);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }

      setIsLoading(false);
    }

    onLoad();
  }, []);

  async function handleSwitchToggle(vendor) {
    const confirmed = window.confirm(
      `Are you sure you want to ${vendor.active ? 'disable' : 'enable'} ${vendor.name}?`
    );

    if (!confirmed || !vendor) {
      return;
    }

    vendor.active = !vendor.active;

    try {
      setVendorLoading(vendor.id);
      await BZAPIService.toggleVendor(vendor.id, vendor.active);
      const vendors = await BZAPIService.getVendors();
      setVendors(vendors);
      setVendorLoading('');
    } catch (e) {
      console.log(e);
      setVendorLoading('');
      toast.error('Failed to update vendor');
    }
  }

  async function handleSectionsToggle(section) {
    const confirm = window.confirm(
      `Are you sure you want to ${section.active ? 'disable' : 'enable'} ${section.label}?`
    );

    if (!confirm || !section) {
      return;
    }

    section.active = !section.active;
    section.active === false ? (section.active = 0) : (section.active = 1);
    console.log('section: ', section);
    setDashboardSections([...dashboardSections]);

    try {
      setDashboardSectionsLoading(section.value);
      const payload = {
        type: 'global',
        bugZeroDashboard: {
          display: dashboardSections
        }
      };
      await BZAPIService.postBzDashboard(payload);
      const sections = await BZAPIService.getBzDashboard();
      setDashboardSections(sections.data.bugZeroDashboard.display);
      setDashboardSectionsLoading('');
      toast.success(`${section.label} updated successfully.`);
    } catch (e) {
      console.log(e);
      setDashboardSectionsLoading('');
      toast.error('Failed to update section');
    }
  }

  function renderDashboardSections(dashboardSections) {
    return dashboardSections.map(section => {
      return (
        <tr key={section.value + '-row'}>
          <td style={{ padding: 0 }}>
            <p
              style={{
                display: 'inline-block',
                width: '100%',
                height: '100%',
                padding: '1em'
              }}
            >
              {section.label}
            </p>
          </td>
          <td>
            <div className="position-relative">
              <Switch
                onChange={() => handleSectionsToggle(section)}
                checked={section.active ? true : false}
                onColor="#617E71"
              />
              <Spinner
                size="sm"
                className={`${section.value === dashboardSectionsLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
              />
            </div>
          </td>
        </tr>
      );
    });
  }

  function renderVendorList(vendors) {
    return vendors?.map(vendor => {
      if (vendor.id === 'servicenow') {
        return <></>;
      } else {
        return (
          <tr key={vendor.id + '-row'}>
            <td style={{ padding: 0 }}>
              <Link
                style={{
                  display: 'inline-block',
                  width: '100%',
                  height: '100%',
                  padding: '1em'
                }}
                key={vendor.id}
                to={`/vendors/${vendor.id}/configuration`}
              >
                {vendor.name}
              </Link>
            </td>

            <td>
              <div className="position-relative">
                <Switch
                  onChange={() => handleSwitchToggle(vendor)}
                  checked={vendor.active ? true : false}
                  onColor="#617E71"
                  // disabled={`${vendor.id === vendorLoading ? false : true}`}
                />
                <Spinner
                  size="sm"
                  className={`${vendor.id === vendorLoading ? 'ml-2 active position-absolute' : 'd-none'}`}
                />
              </div>
            </td>
          </tr>
        );
      }
    });
  }

  if (isLoading) return <Loader />;

  return (
    <>
      <Heading title={'Super Admin'} subtitle={`Manage sections & vendors`} className="mb-4 mt-3" icon="list" />
      <Card className="mb-4">
        <CardHeader>BugZero App Version</CardHeader>
        <CardBody className="fs--1">
          <Table striped bordered hover style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Deployed version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{appVersion}</td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardHeader>Dashboard Sections</CardHeader>
        <CardBody className="fs--1">
          {dashboardSections?.length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Enabled</th>
                </tr>
              </thead>
              <tbody>
                {dashboardSections?.length ? renderDashboardSections(dashboardSections) : 'Failed to load sections'}
              </tbody>
            </Table>
          ) : (
            <div className="text-center">No dashboard sections to manage....</div>
          )}
        </CardBody>
      </Card>
      <Card>
        <CardHeader>Vendors</CardHeader>
        <CardBody className="fs--1">
          {vendors?.length ? (
            <Table striped bordered hover style={{ marginTop: '20px' }}>
              <thead className="card-header">
                <tr>
                  <th>Name</th>
                  <th>Enabled</th>
                </tr>
              </thead>
              <tbody>{renderVendorList(vendors)}</tbody>
            </Table>
          ) : (
            <div className="text-center">No vendors to manage....</div>
          )}
        </CardBody>
      </Card>
    </>
  );
}
